import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 80,
  },
  title: {
    marginBottom: 16,
  },
  item: {
    marginBottom: 80,
  },
  listFigures: {
    position: 'relative',
    height: 249,
  },
  blue: { color: theme.palette.primary.dark },
  pink: { color: theme.palette.secondary.main },
  yellow: { color: '#FFCF52' },
  purple: { color: '#B362FF' },
  [theme.breakpoints.up('sm')]: {
    container: {
      marginTop: 24,
    },
    item: {
      position: 'relative',
      marginBottom: 27,
      display: 'grid',
      gap: 30,
      gridTemplateColumns: '1fr 1fr',
      gridAutoFlow: 'dense',
      '&:nth-of-type(2n+1)': {
        '& $listText': {
          gridColumn: 2,
        },
        '& $listFigures': {
          gridColumn: 1,
        },
      },
    },
    listFigures: {
      height: 378,
    },
    listText: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  [theme.breakpoints.up('md')]: {
    listText: {
      /* nesting */
    },
    item: {
      '&:nth-of-type(even)': {
        '& $listText': {
          paddingLeft: 100,
        },
      },
      '&:nth-of-type(odd)': {
        '& $listText': {
          paddingRight: 100,
        },
      },
    },
  },
}));

export default useStyles;
